module.exports = {
  "calendar": "\u0397\u03BC\u03B5\u03C1\u03BF\u03BB\u03CC\u03B3\u03B9\u03BF",
  "day": "\u03B7\u03BC\u03AD\u03C1\u03B1",
  "dayPeriod": "\u03C0.\u03BC./\u03BC.\u03BC.",
  "endDate": "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2",
  "era": "\u03C0\u03B5\u03C1\u03AF\u03BF\u03B4\u03BF\u03C2",
  "hour": "\u03CE\u03C1\u03B1",
  "minute": "\u03BB\u03B5\u03C0\u03C4\u03CC",
  "month": "\u03BC\u03AE\u03BD\u03B1\u03C2",
  "second": "\u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "\u0395\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B7 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "\u0395\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03BF \u03B5\u03CD\u03C1\u03BF\u03C2: ".concat(args.startDate, " \u03AD\u03C9\u03C2 ").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "\u0395\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B7 \u03CE\u03C1\u03B1: ".concat(args.time);
  },
  "startDate": "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03AD\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2",
  "timeZoneName": "\u03B6\u03CE\u03BD\u03B7 \u03CE\u03C1\u03B1\u03C2",
  "weekday": "\u03BA\u03B1\u03B8\u03B7\u03BC\u03B5\u03C1\u03B9\u03BD\u03AE",
  "year": "\u03AD\u03C4\u03BF\u03C2"
};